import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const MONTHS_PT = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];

export const MonthYearFilter = ({ month, year, onMonthChange, onYearChange, years }) => (
  <>
    <div className="space-y-1">
      <Label className="text-xs text-slate-500">Mês</Label>
      <Select value={month} onValueChange={onMonthChange}>
        <SelectTrigger className="w-40" data-testid="filter-month">
          <SelectValue placeholder="Todos" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" data-testid="filter-month-all">Todos os meses</SelectItem>
          {MONTHS_PT.map((m, i) => (
            <SelectItem key={m} value={String(i + 1).padStart(2, "0")} data-testid={`filter-month-${i + 1}`}>
              {m}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
    <div className="space-y-1">
      <Label className="text-xs text-slate-500">Ano</Label>
      <Select value={year} onValueChange={onYearChange}>
        <SelectTrigger className="w-28" data-testid="filter-year">
          <SelectValue placeholder="Todos" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" data-testid="filter-year-all">Todos</SelectItem>
          {years.map((y) => (
            <SelectItem key={y} value={y} data-testid={`filter-year-${y}`}>{y}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  </>
);
